@if (invoice()) {
  <div class="card">
      <div class="left-elements">
          <div class="customer-name">{{invoice()!.customerName}}</div>
          <div class="lower-elements">
              <div class="invoice-count">{{invoice()!.invoiceCountStatement}}</div>
              <div class="currency-code">{{invoice()!.currency}}</div>
          </div>
      </div>
      <div class="right-elements">
          <div class="remaining-amount">{{invoice()!.totalRemainingAmount.displayValue}}</div>
      </div>
  </div>
}
